import { render, staticRenderFns } from "./SelectCourse.vue?vue&type=template&id=5dcc291b&"
import script from "./SelectCourse.vue?vue&type=script&lang=js&"
export * from "./SelectCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports